export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
export const PAGINATION = 'PAGINATION';
export const SET_ERRORS = 'SET_ERRORS';
export const RESET_STATE = 'RESET_STATE';
